import React, { useState } from 'react'
import { Collapse } from 'reactstrap'
import HobiFlowerSvg from '../../../assets/icons/HobiFlowerSvg'
import { IconCalendarWeekFilled, IconTicket, IconInfoCircle } from '@tabler/icons-react'
const HobiListItem = ({ title, basvuru_tarihi, basvuru_no, kura_durum, kura_tarihi }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleApp = () => setIsOpen(!isOpen)

  return (
    <>
      <div
        className='applications'
        onClick={toggleApp}
        style={{
          transition: 'border-color 0.8s ease',
          boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
          border: 'none',
        }}
      >
        <div className='applications-text'>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                padding: '0.8rem 0.9rem',
                background: 'radial-gradient(#E5ECE9,#93BCAA)',
              }}
            >
              <HobiFlowerSvg width={'1rem'} height={'1rem'} focus={false} />
            </div>
            <p style={{ margin: 0, fontWeight: 'normal' }}>{title}</p>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '5px',
              backgroundColor: '#205c42',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minWidth: '4rem',
                minHeight: '2rem',
                fontSize: '11px',
                color: '#fff',
              }}
            >
              {isOpen ? 'Gizle' : 'Detaylar'}
            </div>
          </div>
        </div>
      </div>
      <div className='userInfoDiv'>
        <Collapse isOpen={isOpen}>
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
                fontSize: '14px',
                backgroundColor: '#F3F3F3',
                width: '90vw',
                padding: '0.35rem 0.5rem',
              }}
            >
              <IconCalendarWeekFilled />
              <div
                style={{
                  fontWeight: '700',
                  marginLeft: '10px',
                  marginRight: '2.5px',
                }}
              >
                Başvuru Tarihi:
              </div>
              <div>{basvuru_tarihi}</div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
                fontSize: '14px',
                backgroundColor: '#fff',
                width: '90vw',
                padding: '0.35rem 0.4rem',
                border: '1px solid #f3f3f3',
              }}
            >
              <IconTicket />
              <div
                style={{
                  fontWeight: '700',
                  marginLeft: '10px',
                  marginRight: '2.5px',
                }}
              >
                Başvuru Numarası:
              </div>
              <div>{basvuru_no}</div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
                fontSize: '14px',
                backgroundColor: '#F3F3F3',
                width: '90vw',
                padding: '0.35rem 0.5rem',
              }}
            >
              <IconInfoCircle />
              <div
                style={{
                  fontWeight: '700',
                  marginLeft: '10px',
                  marginRight: '2.5px',
                }}
              >
                Kura Durumu:{' '}
              </div>
              <div
                style={{
                  padding: '0 .5rem .1rem .5rem',
                  fontWeight: '500',
                  borderRadius: '50px',
                  color: '#fff',
                  backgroundColor: '#FF9900',
                }}
              >
                {kura_durum}
              </div>
            </div>
            {kura_tarihi ? (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  fontSize: '14px',
                  backgroundColor: '#fff',
                  width: '90vw',
                  padding: '0.35rem 0.4rem',
                  border: '1px solid #f3f3f3',
                }}
              >
                <IconCalendarWeekFilled />
                <div
                  style={{
                    fontWeight: '700',
                    marginLeft: '10px',
                    marginRight: '2.5px',
                  }}
                >
                  Kura Tarihi:
                </div>
                <div>{kura_tarihi}</div>
              </div>
            ) : null}
          </div>
        </Collapse>
      </div>
    </>
  )
}

export default HobiListItem
